import type { EmailValue } from 'components/EmailTo'
import {
  API_CONSTRUCTION_LEDGER,
  API_LOAN_CHARGE,
  API_LOAN_CHARGE_UPDATE,
  API_LOAN_CONTACT,
  API_LOAN_CONTACT_UPDATE,
  API_LOAN_CREATE_SERVICE_EXTENSION,
  API_LOAN_DOWNLOAD_LOAN_INTAKE_DOC,
  API_LOAN_DOWNLOAD_SERVICING_DOC2,
  API_LOAN_FCI_ATTACHMENTS,
  API_LOAN_FCI_BORROWER_PAYMENTS,
  API_LOAN_FCI_CHARGES,
  API_LOAN_FCI_DOWNLOAD_ATTACHMENTS,
  API_LOAN_FCI_FUNDING_HISTORY,
  API_LOAN_FCI_LOAN_DETAIL,
  API_LOAN_FCI_LOANPORTFOLIO,
  API_LOAN_GENERATE_PAYOFF,
  API_LOAN_GET_ACH,
  API_LOAN_GET_LOAN_INTAKE_DOCUMENTS_DATA,
  API_LOAN_GET_ONE_SERVICE_EXTENSION,
  API_LOAN_GET_ORDER_OUTS,
  API_LOAN_GET_ORDER_OUTS_CHECK_PLACEHOLDER,
  API_LOAN_GET_ORDER_OUTS_DOWNLOAD,
  API_LOAN_GET_SERVICE_EXTENSION,
  API_LOAN_GET_SERVICING_BORROWING_BASE,
  API_LOAN_GET_SERVICING_BORROWING_BASE_LOG,
  API_LOAN_GET_SERVICING_DEFAULT_TRACKING,
  API_LOAN_GET_SERVICING_DEFAULT_TRACKING_LOG,
  API_LOAN_GET_SERVICING_DOCUMENTS_DATA,
  API_LOAN_GET_SERVICING_NOTES,
  API_LOAN_GET_SERVICING_NOTES_LOG,
  API_LOAN_INVESTOR,
  API_LOAN_INVESTOR_UPDATE,
  API_LOAN_INVOICE,
  API_LOAN_INVOICE_DOWNLOAD,
  API_LOAN_INVOICE_LOG,
  API_LOAN_INVOICE_UPDATE,
  API_LOAN_PAYMENT,
  API_LOAN_PAYMENT_BY_ID,
  API_LOAN_PAYMENT_DOWNLOAD,
  API_LOAN_PAYMENT_FILL,
  API_LOAN_PENALTY,
  API_LOAN_SEND_LOAN_INTAKE_DOC_EMAIL,
  API_LOAN_SEND_SERVICING_DOC_EMAIL,
  API_LOAN_SERVICING_PARTICIPATION,
  API_LOAN_TRUST_LEDGER_DRAW_ISSUED_TASK,
  API_LOAN_TRUST_LEDGER_INTEREST,
  API_LOAN_TRUST_LEDGER_INTEREST_CREATE,
  API_LOAN_TRUST_LEDGER_INTEREST_DELETE,
  API_LOAN_TRUST_LEDGER_INTEREST_UPDATE,
  API_LOAN_TRUST_LEDGER_ORDER_HISTORY,
  API_LOAN_UPDATE_SERVICE_EXTENSION,
  API_NOTE,
  API_NOTE_BY_ID,
  API_NOTE_READ_BY_ID,
  API_TRUST_LEDGER,
  API_TRUST_LEDGER_ADDITIONAL,
  API_TRUST_LEDGER_ADDITIONAL_INFO,
  API_TRUST_LEDGER_NOTIFICATION,
  API_TRUST_LEDGER_STATUS_CHANGE_DRAW_AGREEMENT,
  API_TRUST_LEDGER_VALIDATE_SIGN_SIGNATURE,
  BaseFile,
} from 'config'
import { NotePageType } from 'pages/Loan/Servicing/Notes/types'
import Api from 'services/api'

import { downloadFile } from '../documents'

export const getServicingBorrowingBaseLog = (key: string) => {
  return Api.get(API_LOAN_GET_SERVICING_BORROWING_BASE_LOG, {}, { key })
}

export const getServicingBorrowingBase = () => {
  return Api.get(API_LOAN_GET_SERVICING_BORROWING_BASE)
}

export const postServicingBorrowingBase = (data: Record<string, any>) => {
  return Api.post(API_LOAN_GET_SERVICING_BORROWING_BASE, data)
}

export const getServicingDefaultTrackingLog = (key: string) => {
  return Api.get(API_LOAN_GET_SERVICING_DEFAULT_TRACKING_LOG, {}, { key })
}

export const getServicingDefaultTracking = () => {
  return Api.get(API_LOAN_GET_SERVICING_DEFAULT_TRACKING)
}

export const postServicingDefaultTracking = (data: Record<string, any>) => {
  return Api.post(API_LOAN_GET_SERVICING_DEFAULT_TRACKING, data)
}

export const getServicingNotes = () => {
  return Api.get(API_LOAN_GET_SERVICING_NOTES)
}

export const postServicingNotes = (data: object) => {
  return Api.post(API_LOAN_GET_SERVICING_NOTES, data)
}

export const getServicingDocumentData = () => {
  return Api.get(API_LOAN_GET_SERVICING_DOCUMENTS_DATA)
}

export const getLoanIntakeDocumentData = () => {
  return Api.get(API_LOAN_GET_LOAN_INTAKE_DOCUMENTS_DATA)
}

export const downloadServicingDocs2 = async (doc: Record<string, any>) => {
  const response: Blob = await Api.post(
    API_LOAN_DOWNLOAD_SERVICING_DOC2,
    { name: doc.name, source: doc.source },
    {},
    {
      responseType: 'blob',
    },
  )

  downloadFile(`${name} - ${Api.getLoanNumber()}.pdf`, response)
}

export const downloadLoanIntakeDocs = async (name: string) => {
  const response: Blob = await Api.post(
    API_LOAN_DOWNLOAD_LOAN_INTAKE_DOC,
    { name },
    {},
    {
      responseType: 'blob',
    },
  )

  downloadFile(`${name} - ${Api.getLoanNumber()}.pdf`, response)
}

export const sendServicingDocumentOnEmail = (
  doc: Record<string, any>,
  emailData: Record<string, string>,
  data: Record<string, any>,
) => {
  return Api.post(API_LOAN_SEND_SERVICING_DOC_EMAIL, { name: doc.name, source: doc.source, emailData, data })
}

export const sendLoanIntakeDocumentEmail = (
  name: string,
  emailData: Record<string, string>,
  data: Record<string, any>,
) => {
  return Api.post(API_LOAN_SEND_LOAN_INTAKE_DOC_EMAIL, { name, emailData, data })
}

export const getServicingParticipation = () => {
  return Api.get(API_LOAN_SERVICING_PARTICIPATION)
}

export const saveServicingParticipation = async (loanNumber: number, byteproFileName: number, data: any) => {
  const response: Blob = await Api.post(
    API_LOAN_SERVICING_PARTICIPATION,
    data,
    {},
    {
      responseType: 'blob',
    },
  )

  downloadFile(`Participation Agreement - ${byteproFileName || loanNumber}.pdf`, response)
}

/**
 * Trust Ledger
 */

export const validateTrustLedgerSignature = (data: object) => {
  return Api.post(API_TRUST_LEDGER_VALIDATE_SIGN_SIGNATURE, data)
}

export const changeTrustLedgerAgreementStatus = (data: object) => {
  return Api.post(API_TRUST_LEDGER_STATUS_CHANGE_DRAW_AGREEMENT, data)
}

export const getTrustLedger = () => {
  return Api.get(API_TRUST_LEDGER)
}

export const getTrustLedgerAdditionalInfo = () => {
  return Api.get(API_TRUST_LEDGER_ADDITIONAL_INFO)
}

export const addTrustLedger = (data: Record<string, any>) => {
  return Api.post(API_TRUST_LEDGER, data)
}

export const updateTrustLedger = (id: number, data: Record<string, any>) => {
  return Api.put(`${API_TRUST_LEDGER}/${id}`, data)
}

export const updateTrustLedgerAdditional = (data: Record<string, any>) => {
  return Api.put(API_TRUST_LEDGER_ADDITIONAL, data)
}

export const getTrustLedgerAdditionalHistory = (key: string) => {
  return Api.get(API_TRUST_LEDGER_ADDITIONAL, { key })
}

export const deleteTrustLedger = (id: number) => {
  return Api.delete(`${API_TRUST_LEDGER}/${id}`)
}

export const getConstructionLedger = () => {
  return Api.get(API_CONSTRUCTION_LEDGER)
}

export const submitTrustLedgerAfx = (id: number, data: Record<string, any>) => {
  return Api.post(`${API_TRUST_LEDGER}Afx/:id`, data, { id })
}

export const getTrustLedgerAfx = () => {
  return Api.get(`${API_TRUST_LEDGER}Afx`)
}

// Interest Trust Ledger
export const getTrustLedgerInterest = () => {
  return Api.get(API_LOAN_TRUST_LEDGER_INTEREST)
}
export const createTrustLedgerInterest = (data: Record<string, any>) => {
  return Api.post(API_LOAN_TRUST_LEDGER_INTEREST_CREATE, data)
}

export const updateTrustLedgerInterest = (id: string, data: Record<string, any>) => {
  return Api.put(API_LOAN_TRUST_LEDGER_INTEREST_UPDATE, data, { id })
}

export const deleteTrustLedgerInterest = (id: string) => {
  return Api.delete(API_LOAN_TRUST_LEDGER_INTEREST_DELETE, {}, { id })
}

export const trustLedgerDrawIssuedAccountingTask = (data: any) => {
  return Api.post(API_LOAN_TRUST_LEDGER_DRAW_ISSUED_TASK, data)
}

export const getTrustLedgerOrderHistory = (id: number) => {
  return Api.get(API_LOAN_TRUST_LEDGER_ORDER_HISTORY, {}, { id })
}

export const sendTrustLedgerNotification = (
  ID: number,
  emails: EmailValue,
  emailType: string,
  files: Record<string, string>[],
  data: any,
) => {
  return Api.post(API_TRUST_LEDGER_NOTIFICATION, { ID, emails, emailType, files, data })
}

/**
 * Loan Service Extension
 */
export const updateLoanServiceExtension = (data: any, id: number) => {
  return Api.post(API_LOAN_UPDATE_SERVICE_EXTENSION, { data }, { id })
}

export const createLoanServiceExtension = (data: any) => {
  return Api.post(API_LOAN_CREATE_SERVICE_EXTENSION, data)
}

export const getLoanServiceExtension = () => {
  return Api.get(API_LOAN_GET_SERVICE_EXTENSION)
}

export const getOneLoanServiceExtension = (id: string) => {
  return Api.get(API_LOAN_GET_ONE_SERVICE_EXTENSION, {}, { id })
}

export const sendEmailForLoanServiceExtension = (id: number) => {
  return Api.put(API_LOAN_UPDATE_SERVICE_EXTENSION, {}, { id })
}

/**
 * Notes
 */
export const getNotes = (loanNumber: number, filters: Record<string, any>) => {
  return Api.get(API_NOTE, filters, { loanNumber })
}

export const addNewNote = (
  loanNumber: number,
  subject: string,
  content: string,
  files: BaseFile[] = [],
  notifiers: EmailValue = {},
  isEmail: boolean = false,
  replyData: Record<string, any> | null = null,
  notePageType: NotePageType = NotePageType.GLOBAL,
  links: any[] = [],
) => {
  return Api.post(
    API_NOTE,
    { subject, content, files, notifiers, isEmail, replyData, notePageType, links },
    { loanNumber },
  )
}

export const updateNote = (id: number, subject: string, content: string, files: BaseFile[], notifiers: EmailValue) => {
  return Api.put(API_NOTE_BY_ID, { subject, content, files, notifiers }, { id })
}

export const updateReadStatus = (id: number) => {
  return Api.put(API_NOTE_READ_BY_ID, {}, { id })
}

export const deleteNote = (id: number) => {
  return Api.delete(API_NOTE_BY_ID, {}, { id })
}

/**
 * Invoices
 */
export const getLoanInvoices = (filters: Record<string, any>) => {
  return Api.get(API_LOAN_INVOICE, filters)
}

export const addNewLoanInvoice = (data: Record<string, any>) => {
  return Api.post(API_LOAN_INVOICE, data)
}

export const updateLoanInvoice = (id: number, data: Record<string, any>) => {
  return Api.put(API_LOAN_INVOICE_UPDATE, data, { id })
}

export const deleteLoanInvoice = (id: number) => {
  return Api.delete(API_LOAN_INVOICE_UPDATE, {}, { id })
}

export const downloadInvoices = async (isLoan: boolean) => {
  const res: Blob = await Api.get(
    API_LOAN_INVOICE_DOWNLOAD,
    { isLoan },
    {},
    {
      responseType: 'blob',
    },
  )
  downloadFile(`Invoices.csv`, res)
}

export const getInvoiceLogs = (id: number, key: string) => {
  return Api.get(API_LOAN_INVOICE_LOG, {}, { id, key })
}

export const getLoanPayments = () => {
  return Api.get(API_LOAN_PAYMENT)
}

export const createLoanPayment = (data: Record<string, any>) => {
  return Api.post(API_LOAN_PAYMENT, data)
}

export const updateLoanPayment = (id: number, data: Record<string, any>) => {
  return Api.put(API_LOAN_PAYMENT_BY_ID, data, { id })
}

export const deleteLoanPayment = (id: number) => {
  return Api.delete(API_LOAN_PAYMENT_BY_ID, {}, { id })
}

export const getLoanPaymentFillData = () => {
  return Api.get(API_LOAN_PAYMENT_FILL)
}

export const downloadLoanPayments = async (format: 'csv' | 'xls') => {
  const response: Blob = await Api.get(
    API_LOAN_PAYMENT_DOWNLOAD,
    {},
    { format },
    {
      responseType: 'blob',
    },
  )

  downloadFile(`LoanPayments.${format}`, response)
}

export const getFciLoanPortfolio = () => {
  return Api.get(API_LOAN_FCI_LOANPORTFOLIO)
}

export const getFciLoanDetail = (servicerNo: number = 0) => {
  return Api.get(API_LOAN_FCI_LOAN_DETAIL, { servicerNo })
}

export const getFciBorrowerPayments = (servicerNo: number = 0) => {
  return Api.get(API_LOAN_FCI_BORROWER_PAYMENTS, { servicerNo })
}

export const getFciCharges = (servicerNo: number = 0) => {
  return Api.get(API_LOAN_FCI_CHARGES, { servicerNo })
}

export const getFciFundingHistory = (servicerNo: number = 0) => {
  return Api.get(API_LOAN_FCI_FUNDING_HISTORY, { servicerNo })
}

export const getFciAttachments = (servicerNo: number = 0) => {
  return Api.get(API_LOAN_FCI_ATTACHMENTS, { servicerNo })
}

export const downloadFciAttachments = (uid: string) => {
  return Api.post(API_LOAN_FCI_DOWNLOAD_ATTACHMENTS, { uid }, {}, { responseType: 'blob', timeout: 150000 })
}

export const getServicngNotesLogs = (key: string) => {
  return Api.get(API_LOAN_GET_SERVICING_NOTES_LOG, {}, { key })
}

export const getLoanCharges = (filters: Record<string, any>) => {
  return Api.get(API_LOAN_CHARGE, filters)
}

export const addNewLoanCharge = (data: Record<string, any>) => {
  return Api.post(API_LOAN_CHARGE, data)
}

export const updateLoanCharge = (id: number, data: Record<string, any>) => {
  return Api.put(API_LOAN_CHARGE_UPDATE, data, { id })
}

export const deleteLoanCharge = (id: number) => {
  return Api.delete(API_LOAN_CHARGE_UPDATE, {}, { id })
}

export const downloadPayoff = (data: Record<string, any>) => {
  return Api.post(API_LOAN_GENERATE_PAYOFF, data, {}, { responseType: 'blob', timeout: 150000 })
}

export const getLoanContacts = (filters: Record<string, any>) => {
  return Api.get(API_LOAN_CONTACT, filters)
}

export const addNewLoanContact = (data: Record<string, any>) => {
  return Api.post(API_LOAN_CONTACT, data)
}

export const updateLoanContact = (id: number, data: Record<string, any>) => {
  return Api.put(API_LOAN_CONTACT_UPDATE, data, { id })
}

export const deleteLoanContact = (id: number) => {
  return Api.delete(API_LOAN_CONTACT_UPDATE, {}, { id })
}

export const getACH = () => {
  return Api.get(API_LOAN_GET_ACH)
}

export const postACH = (data: object) => {
  return Api.post(API_LOAN_GET_ACH, data)
}

export const getPenalty = () => {
  return Api.get(API_LOAN_PENALTY)
}

export const postPenalty = (data: object) => {
  return Api.post(API_LOAN_PENALTY, data)
}

export const getOrderOuts = () => {
  return Api.get(API_LOAN_GET_ORDER_OUTS)
}

export const postOrderOuts = (data: object) => {
  return Api.post(API_LOAN_GET_ORDER_OUTS, data)
}

export const addNewInvestor = (data: Record<string, any>) => {
  return Api.post(API_LOAN_INVESTOR, data)
}

export const getLoanInvestors = () => {
  return Api.get(API_LOAN_INVESTOR)
}

export const updateLoanInvestor = (id: number, data: Record<string, any>) => {
  return Api.put(API_LOAN_INVESTOR_UPDATE, data, { id })
}

export const deleteLoanInvestor = (id: number) => {
  return Api.delete(API_LOAN_INVESTOR_UPDATE, {}, { id })
}

export const generateOrderOut = async (loanNumber: number, title: string, byteproFileName: number) => {
  const response: Blob = await Api.post(
    API_LOAN_GET_ORDER_OUTS_DOWNLOAD,
    { title },
    {},
    {
      responseType: 'blob',
    },
  )

  downloadFile(`${title} - ${byteproFileName || loanNumber}.pdf`, response)
}

export const generateOrderOutCheckPlaceholder = async (loanNumber: number, title: string) => {
  return await Api.post(
    API_LOAN_GET_ORDER_OUTS_CHECK_PLACEHOLDER,
    { title },
    {},
    {
      timeout: 150000,
    },
  )
}
